import { render, staticRenderFns } from "./TitleDetailStreamingChart.vue?vue&type=template&id=4bb72088&scoped=true"
import script from "./TitleDetailStreamingChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailStreamingChart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailStreamingChart.vue?vue&type=style&index=0&id=4bb72088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb72088",
  null
  
)

export default component.exports